import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";

import { BackednResponse } from "@shared/lib/types";
import { REPORTS_LIST_QUERY_KEY } from "../constants";

import { ReportService } from "../services/Report.servie";
import { IReportDetail } from "@shared/lib/types/reports";

export function useGetReportDetail(
  id: string,
  isNonTrackable: boolean = false,
  facets?: {
    [key: string]: string[];
  },
  limit: number = 10,
  pageNo: number = 1
) {
  const queryKey = [
    REPORTS_LIST_QUERY_KEY,
    id,
    isNonTrackable,
    facets,
    limit,
    pageNo,
  ];

  const { data, isFetching, isError, error, refetch } = useQuery<
    BackednResponse<IReportDetail>
  >({
    queryKey,
    queryFn: () =>
      ReportService.getReportDetail(id, isNonTrackable, facets, limit, pageNo),
    enabled: !!id,
  });

  const errorMessage = isError && error?.message;

  if (errorMessage) {
    ToastService.error(errorMessage);
  }

  return {
    report: data?.data,
    isFetching,
    isError,
    pagination: data?.data?.pagination,
    refetch,
    queryKey,
  };
}
